import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import ImageView from 'general/components/quybka/Images/ImageView';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogMaintainerCompleteTicketView.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogMaintainerCompleteTicketView({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [invoiceDocument, setInvoiceDocument] = useState([]);

    // MARK: ---- FUNCTIONS ----
    const handleUploadFile = async (fileList) => {
        if (!fileList || fileList?.length === 0) {
            return [];
        }

        try {
            const uploadPromises = fileList.map(async (fileObj) => {
                let res;
                if (fileObj?.file) {
                    res = await miscHelper.callApiUploadFile(fileObj?.file);
                } else {
                    res = await miscHelper.callApiUploadFile(fileObj);
                }
                return res[0]?.relativePath;
            });

            const newImagePaths = await Promise.all(uploadPromises);
            return newImagePaths.filter(path => path);
        } catch (error) {
            console.error('Error uploading files:', error);
            ToastHelper.showError('Upload file thất bại');
            return [];
        }
    };

    const handleSubmit = async () => {
        if (
            !selectedFiles?.length
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        setLoading(true);

        const imagePaths = await handleUploadFile(selectedFiles);
        const invoiceDocumentPaths = await handleUploadFile(invoiceDocument);

        let params = {
            ticketId: item.ticketId,
            attachedFilesAfter: imagePaths.length > 0 ? imagePaths : undefined,
            invoiceDocument: invoiceDocumentPaths.length > 0 ? invoiceDocumentPaths : undefined,
        };

        params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
        setLoading(true);

        const res = await MaintainerHelper.API.requestCompleteTicket(params);
        if (_.isBoolean(res) && res) {
            MaintainerHelper.UI.showDialogNoticeCompleteTicketSuccess(item, onDone);
        } else if (_.isString(res)) {
            ToastHelper.showError(res);
        }
        setLoading(false);
    };

    const handleFilesChanged = (e) => {
        const newFiles = e.target.files;
        if (!newFiles || newFiles.length === 0) return;

        const filesArray = Array.from(newFiles);
        const validFiles = [];

        const MAX_SIZE_MB = 100;

        filesArray.forEach((file) => {
            const sizeInMB = file.size / (1024 * 1024);
            if (sizeInMB > MAX_SIZE_MB) {
                ToastHelper.showError(`File "${file.name}" vượt quá ${MAX_SIZE_MB}MB.`);
                return;
            }

            validFiles.push({
                file,
                preview: URL.createObjectURL(file),
                type: file.type,
            });
        });

        if (validFiles.length > 0) {
            const tmpSelectedFiles = [...selectedFiles, ...validFiles];
            setSelectedFiles(tmpSelectedFiles);
        }

        e.target.value = null;
    };

    const handleRemoveFile = (index) => {
        const tmp = [...selectedFiles];
        URL.revokeObjectURL(tmp[index].preview);
        tmp.splice(index, 1);
        setSelectedFiles(tmp);
    };

    const handleInvoiceDocumentChanged = (e) => {
        const newFiles = e.target.files;
        if (!newFiles || newFiles.length === 0) return;

        const filesArray = Array.from(newFiles);
        const validFiles = [];

        const MAX_SIZE_MB = 100;
        const MAX_NAME_LENGTH = 128;

        filesArray.forEach((file) => {
            const sizeInMB = file.size / (1024 * 1024);
            if (sizeInMB > MAX_SIZE_MB) {
                ToastHelper.showError(`File "${file.name}" vượt quá ${MAX_SIZE_MB}MB.`);
                return;
            }

            if (file.name.length > MAX_NAME_LENGTH) {
                ToastHelper.showError(`Tên file "${file.name}" quá dài (tối đa ${MAX_NAME_LENGTH} ký tự).`);
                return;
            }

            const isAllowed =
                file.type.startsWith('image/') ||
                file.type.startsWith('video/') ||
                file.type === 'application/pdf';

            if (!isAllowed) {
                ToastHelper.showError(`File "${file.name}" không được hỗ trợ. Chỉ chấp nhận ảnh, video và PDF.`);
                return;
            }

            validFiles.push({
                file,
                preview: URL.createObjectURL(file),
                type: file.type,
            });
        });

        if (validFiles.length > 0) {
            const tmpInvoiceDocument = [...invoiceDocument, ...validFiles];
            setInvoiceDocument(tmpInvoiceDocument);
        }

        e.target.value = null;
    };

    const handleRemoveInvoiceDocument = (index) => {
        const tmp = [...invoiceDocument];
        URL.revokeObjectURL(tmp[index].preview);
        tmp.splice(index, 1);
        setInvoiceDocument(tmp);
    };

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* attachFiles */}
                <div className="col-6 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Ảnh, video sau sửa chữa/bảo trì', true)}
                        <div className="multi-media-upload">
                            <button
                                type="button"
                                className="upload-button border-none px-6 py-4 rounded-sm d-flex"
                                onClick={() => document.getElementById('multi-media-input').click()}
                                style={{ backgroundColor: AppColors.gray[200] }}
                            >
                                <i className="fa-regular fa-upload mr-3" style={{ color: AppColors.gray[800] }} />
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Thêm tệp tin
                                </span>
                            </button>

                            <input
                                id="multi-media-input"
                                type="file"
                                multiple
                                accept="image/*,video/*"
                                style={{ display: 'none' }}
                                onChange={handleFilesChanged}
                            />
                            {selectedFiles.length > 0 && (
                                <div className="preview-grid mt-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '5px', marginBottom: '16px' }}>
                                    {selectedFiles.map((fileObj, index) => (
                                        <div
                                            key={index}
                                            className="position-relative"
                                            style={{
                                                width: '230px',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                background: '#f8f9fa',
                                            }}
                                        >
                                            {fileObj.type.startsWith('image/') ? (
                                                <img
                                                    src={fileObj.preview}
                                                    alt="preview"
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        display: 'block',
                                                    }}
                                                />
                                            ) : (
                                                <video
                                                    src={fileObj.preview}
                                                    controls
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        display: 'block',
                                                        background: '#000',
                                                    }}
                                                />
                                            )}

                                            <button
                                                type="button"
                                                onClick={() => handleRemoveFile(index)}
                                                className="btn btn-xs btn-icon btn-circle btn-secondary"
                                                style={{
                                                    position: 'absolute',
                                                    top: '8px',
                                                    right: '8px',
                                                    zIndex: 10,
                                                }}
                                            >
                                                <i className="ki ki-bold-close icon-xs text-white" />
                                            </button>

                                            <div className="p-2 text-center">
                                                <small
                                                    className="d-block text-muted text-truncate"
                                                    style={{ maxWidth: '140px', fontSize: '11px' }}
                                                    title={fileObj.file.name}
                                                >
                                                    {fileObj.file.name}
                                                </small>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                        </div>
                    </div>
                </div>

                {/* invoiceDocument */}
                <div className="col-6 mb-4 px-2">
                    <div>
                        {UIHelper.buildFormLabel('Tải lên hóa đơn mua hàng')}
                        <div className="multi-media-upload">
                            <button
                                type="button"
                                className="upload-button border-none px-6 py-4 rounded-sm d-flex"
                                onClick={() => document.getElementById('invoice-document-input').click()}
                                style={{ backgroundColor: AppColors.gray[200] }}
                            >
                                <i className="fa-regular fa-upload mr-3" style={{ color: AppColors.gray[800] }} />
                                <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                                    Thêm tệp tin
                                </span>
                            </button>

                            <input
                                id="invoice-document-input"
                                type="file"
                                multiple
                                accept="image/*,video/*,application/pdf"
                                style={{ display: 'none' }}
                                onChange={handleInvoiceDocumentChanged}
                            />
                            {invoiceDocument.length > 0 && (
                                <div className="preview-grid mt-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '5px', marginBottom: '16px' }}>
                                    {invoiceDocument.map((fileObj, index) => (
                                        <div
                                            key={index}
                                            className="position-relative"
                                            style={{
                                                width: '230px',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                background: '#f8f9fa',
                                            }}
                                        >
                                            {fileObj.type.startsWith('image/') ? (
                                                <img
                                                    src={fileObj.preview}
                                                    alt="preview"
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        display: 'block',
                                                    }}
                                                />
                                            ) : fileObj.type.startsWith('video/') ? (
                                                <video
                                                    src={fileObj.preview}
                                                    controls
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        display: 'block',
                                                        background: '#000',
                                                    }}
                                                />
                                            ) : (
                                                <ImageView
                                                    name={fileObj?.file?.lastModified ?? fileObj ?? index}
                                                    path={_.isString(fileObj) ? fileObj : fileObj?.file?.name}
                                                    showFileName={false}
                                                />
                                            )}

                                            <button
                                                type="button"
                                                onClick={() => handleRemoveInvoiceDocument(index)}
                                                className="btn btn-xs btn-icon btn-circle btn-secondary"
                                                style={{
                                                    position: 'absolute',
                                                    top: '8px',
                                                    right: '8px',
                                                    zIndex: 10,
                                                }}
                                            >
                                                <i className="ki ki-bold-close icon-xs text-white" />
                                            </button>

                                            <div className="p-2 text-center">
                                                <small
                                                    className="d-block text-muted text-truncate"
                                                    style={{ maxWidth: '140px', fontSize: '11px' }}
                                                    title={fileObj.file.name}
                                                >
                                                    {fileObj.file.name}
                                                </small>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            {/* actions */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    'Xác nhận',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogMaintainerCompleteTicketView;
